module.exports = __webpack_public_path__ + "static/img/hero-bg.e534bb5d.png";